import { CheckCircle2, ExternalLink, Wand2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const TIPO_LABELS = {
  it_activa:           'IT',
  ausencias_regulares: 'Ausencias',
  cambio_salario:      'Cambio salario',
  irpf_divergente:     'IRPF',
  primer_mes:          'Primer mes',
  baja_parcial:        'Baja parcial',
};

/**
 * AutoResolveResult — shown after resolver_periodo_nominas_auto produces a plan.
 * Shows N employees + tipo breakdown + deeplink to the period.
 */
export default function AutoResolveResult({ result }) {
  if (!result) return null;
  const tipos = Object.entries(result.tipo_breakdown ?? {}).filter(([, n]) => n > 0);

  return (
    <div className="rounded-xl border border-success/30 bg-success/10 p-3 my-1 max-w-sm space-y-2">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-foreground">
              <Wand2 className="w-3 h-3 inline text-violet-500" /> Plan de auto-resolución listo
            </p>
            <p className="text-[10px] text-muted-foreground">
              {result.empleados_afectados ?? 0} empleado{(result.empleados_afectados ?? 0) !== 1 ? 's' : ''} · {result.periodo}
            </p>
          </div>
        </div>
        <Link to={`/nominas?periodo=${result.periodo}`}>
          <Button size="sm" variant="outline"
            className="h-7 text-[11px] shrink-0 gap-1 border-success/30 text-success hover:bg-success/10">
            Ver
            <ExternalLink className="w-3 h-3" />
          </Button>
        </Link>
      </div>

      {tipos.length > 0 && (
        <div className="flex flex-wrap gap-1 border-t border-success/30 pt-2">
          {tipos.map(([tipo, n]) => (
            <span key={tipo} className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300">
              {TIPO_LABELS[tipo] ?? tipo} · {n}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
